import { render, staticRenderFns } from "./CompEdit.vue?vue&type=template&id=459eca5a&scoped=true"
import script from "./CompEdit.vue?vue&type=script&lang=js"
export * from "./CompEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459eca5a",
  null
  
)

export default component.exports